module.exports = __webpack_public_path__ + "img/電気回路_4_4_4.549f6c30.png";